import { render, staticRenderFns } from "./dashGroupStudents.vue?vue&type=template&id=54ac6008&scoped=true"
import script from "./dashGroupStudents.vue?vue&type=script&lang=js"
export * from "./dashGroupStudents.vue?vue&type=script&lang=js"
import style0 from "./dashGroupStudents.vue?vue&type=style&index=0&id=54ac6008&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ac6008",
  null
  
)

export default component.exports